import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import ApplicationHeader from "../../../application/ApplicationHeader";
import logo from "../../../application/BiblioBoard_Logo_Stacked.png";
import { Container } from "@mui/material";
import ApplicationPanel from "../../../application/ApplicationPanel";
import PapiServerBrowse from "./PapiServerBrowse";

const useStyles = makeStyles(theme => ({
  panel: {
    padding: 0,
  },

  creatorLogo: {
    width: "100%",
    height: "100%",
  },
}));

const ManagePapiServers = () => {
  const classes = useStyles();

  return (
    <Container
      id="manage-papi-servers"
      maxWidth={false}
      classes={{ root: classes.panel }}
    >
      <ApplicationHeader
        applicationLogo={
          <img className={classes.creatorLogo} alt="Creator" src={logo} />
        }
        applicationNavigationWidth="33%"
      />

      <ApplicationPanel>
        <PapiServerBrowse />
      </ApplicationPanel>
    </Container>
  );
};

export default ManagePapiServers;
